define('shared/util/state/adapters/tracking',[],function (){
    return null;
});
